import defaultAvatar from '../images/avatar1.jpg';

const conversationsList = [
  {
    id: 1,
    status: 1,
    name: 'Alla',
    lastSeen: '17 m',
    lastMessage: 'Lorem ipsum dolar sit amet...',
    unreadedMessages: 100,
    avatar: defaultAvatar,
    messages: [
      {
        type: 'income',
        text: 'Or maybe not, let me check logistics and call you. Give me sometime',
      },
      {
        type: 'out',
        text: 'Or maybe not, let me check logistics and call you. Give me sometime',
      },
    ],
  },
  {
    id: 2,
    status: 1,
    name: 'Alex',
    lastSeen: '22 m',
    lastMessage: 'Lorem ipsum dolar sit amet...',
    unreadedMessages: 1,
    avatar: defaultAvatar,
    messages: [
      {
        type: 'income',
        text: 'I will look into it',
      },
      {
        type: 'out',
        text: 'Exactly my point!',
      },
    ],
  },
  {
    id: 3,
    status: 1,
    name: 'Serhii',
    lastSeen: '22 m',
    lastMessage: 'Lorem ipsum dolar sit amet...',
    unreadedMessages: 1,
    avatar: defaultAvatar,
  },
  {
    id: 4,
    status: 1,
    name: 'Viktor',
    lastSeen: '22 m',
    lastMessage: 'Lorem ipsum dolar sit amet...',
    unreadedMessages: 1,
    avatar: defaultAvatar,
  },
  {
    id: 5,
    status: 1,
    name: 'Meister',
    lastSeen: '22 m',
    lastMessage: 'Lorem ipsum dolar sit amet...',
    unreadedMessages: 1,
    avatar: defaultAvatar,
  },
  {
    id: 6,
    status: 1,
    name: 'Looser',
    lastSeen: '22 m',
    lastMessage: 'Lorem ipsum dolar sit amet...',
    unreadedMessages: 1,
    avatar: defaultAvatar,
  },
  {
    id: 7,
    status: 1,
    name: 'Inquisitor',
    lastSeen: '17 m',
    lastMessage: 'Lorem ipsum dolar sit amet...',
    unreadedMessages: 100,
    avatar: defaultAvatar,
  },
  {
    id: 8,
    status: 1,
    name: 'Stearlead',
    lastSeen: '17 m',
    lastMessage: 'Lorem ipsum dolar sit amet...',
    unreadedMessages: 100,
    avatar: defaultAvatar,
  },
  {
    id: 9,
    status: 1,
    name: 'Stearlead',
    lastSeen: '17 m',
    lastMessage: 'Lorem ipsum dolar sit amet...',
    unreadedMessages: 100,
    avatar: defaultAvatar,
  },
  {
    id: 10,
    status: 1,
    name: 'Stearlead',
    lastSeen: '17 m',
    lastMessage: 'Lorem ipsum dolar sit amet...',
    unreadedMessages: 100,
    avatar: defaultAvatar,
  },
  {
    id: 11,
    status: 1,
    name: 'Stearlead',
    lastSeen: '17 m',
    lastMessage: 'Lorem ipsum dolar sit amet...',
    unreadedMessages: 100,
    avatar: defaultAvatar,
  },
];

export default conversationsList;
